module.exports = __webpack_public_path__ + "img/gem-flag.85f98c37.svg";